import { render, staticRenderFns } from "./task-filter.vue?vue&type=template&id=3b4a2403"
import script from "./task-filter.vue?vue&type=script&lang=js"
export * from "./task-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports